import * as IoC from 'typescript-ioc';

import { IApiClient } from '../../infrastructure/api-client';
import { IOperatorListDTO, IOperatorsDAO, IOperatorsDetailsDTO } from '../operators.dao';
import { IEventRequestParams, IPaginationParams } from '../shared.dto';
import * as OPERATORS_API from '../../constants/api/operators-api';

class OperatorsDAO extends IOperatorsDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getOperators(params: IEventRequestParams): Promise<IOperatorsDetailsDTO[]> {
        const response = await this.apiClient.get<IOperatorsDetailsDTO[]>(OPERATORS_API.OPERATORS_LIST_URL, params);
        return response.parsedResponse;
    }

    public async getAllOperators(params: IPaginationParams): Promise<IOperatorListDTO> {
        const response = await this.apiClient.get<IOperatorListDTO>(OPERATORS_API.ALL_OPERATORS_LIST_URL, params);
        return response.parsedResponse;
    }
}

export { OperatorsDAO };
